import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { Button, Table } from 'antd';

import Loader from 'shared/components/Loader/Loader';
import Search from 'shared/components/Search/Search';

import AddUserModal from '../../shared/AddUserModal/AddUserModal';
import { isSupervisorUser } from '../../../../Auth/redux/auth.redux';

import s from './style/Users.pcss';


const columns = [{
  title: 'Имя',
  dataIndex: 'fullName',
  width: '25%',
  render: (text, record) => (
    <div className={s.nameContainer}>
      <div className={s.name}>{text}</div>
      {record.groupArray &&
        <div className={s.tagList}>
          {record.groupArray.map(group => (
            <div key={group.id} className={s.tagItem}>{group.name}</div>
          ))}
        </div>
      }
    </div>
  ),
},
{
  title: 'E-mail',
  dataIndex: 'email',
  width: '25%',
},
{
  title: 'Должность',
  dataIndex: 'positionName',
  width: '25%',
  render: text => text || 'Не известно',
},
{
  title: 'Подразделение',
  dataIndex: 'unitId.name',
  width: '25%',
  render: text => text || 'Не известно',
}];

@withRouter
@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class Users extends React.Component {
  static propTypes = {
    users: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    total: PropTypes.number.isRequired,
    onAddUsers: PropTypes.func.isRequired,
    onAddGroups: PropTypes.func.isRequired,
    onRemoveUsers: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    roleName: PropTypes.string.isRequired,
    role: PropTypes.shape().isRequired,
    section: PropTypes.shape().isRequired,
    isSupervisor: PropTypes.bool.isRequired,
    sectionPath: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    search: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    match: PropTypes.shape().isRequired,
    location: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    section: {},
    role: {},
  };

  state = {
    selected: [],
    addUserMode: false,
    saving: false,
  };

  handleSearch = filterBy => this.props.onChange('search', filterBy)

  onCloseModal = () => this.setState({ addUserMode: false });
  onOpenModal = () => this.setState({ addUserMode: true });
  onSelectChange = selected => this.setState({ selected });
  cancelSelection = () => this.setState({ selected: [] });

  changePage = ({ current }) => this.props.onChange('page', current);

  addUsers = users => this.props.onAddUsers(users).then(() => {
    this.setState({ addUserMode: false, saving: false });
    return Promise.resolve();
  });

  addGroups = groups => this.props.onAddGroups(groups).then(() => {
    this.setState({ addUserMode: false, saving: false });
    return Promise.resolve();
  });

  removeAccess = () => this.setState({ saving: true }, () => {
    this.props.onRemoveUsers(this.state.selected)
      .then(() => this.setState({ selected: [], saving: false }));
  });

  renderAddModalTitle = () => {
    const { sectionPath, roleName } = this.props;
    return (
      <div className={s.infoContainer}>
        <div className={s.section}>{sectionPath}</div>
        <div className={s.roleContainer}>
          <div className={s.roleLabel}>Роль:</div>
          <div className={s.roleName}>{roleName}</div>
        </div>
      </div>
    );
  };

  render() {
    const { selected, addUserMode, saving } = this.state;
    const { sectionPath, match, section, role, isSupervisor, search } = this.props;
    const rowSelection = {
      selectedRowKeys: selected,
      onChange: this.onSelectChange,
    };
    const isLocked = role.isLocked || (isSupervisor && role.forbiddenForSupervisorAdmin) || section.isLocked;
    const selectionProps = isLocked ? {} : { rowSelection };
    const disabledAdding = !match.params.roleId;
    const loading = {
      spinning: this.props.loading,
      indicator: <Loader fullScreen={false} size={20} />,
    };
    const users = this.props.users
      .filter(u => (u.fullName || '').toLowerCase().indexOf(search.toLowerCase()) !== -1);

    return (
      <div className={s.container}>
        <div className={s.title}>{sectionPath}</div>
        {isLocked &&
          <div className={s.lockedContainer}>
            <div className={s.lockedIcon} />
            <div className={s.hint}>
              Внимание! Вы не можете редактировать эту роль, поскольку она была преднастроена!
            </div>
          </div>
        }
        <div className={`${s.controls} ${selected.length > 0 ? s.selectedControls : ''}`}>
          {selected.length > 0 &&
            <div className={s.selectedCount}>
              {selected.length} значения выбрано
            </div>
          }

          <div className={s.searchContainer}>
            <Search onSearch={this.handleSearch} value={search} />
          </div>

          {!selected.length && !isLocked ? (
            <Button
              type="primary"
              className={s.addBtn}
              disabled={disabledAdding}
              onClick={this.onOpenModal}
            >
              Добавить пользователей
            </Button>
          ) : null}

          <AddUserModal
            users={this.props.users.map(user => user.id)}
            title={this.renderAddModalTitle()}
            onAddUsers={this.addUsers}
            onAddGroups={this.addGroups}
            visible={addUserMode}
            onClose={this.onCloseModal}
          />

          {selected.length > 0 && !saving && !isLocked ? (
            <div className={s.selectedBtns}>
              <div className={s.removeAccessBtn} onClick={this.removeAccess}>Удалить доступ</div>
              <div className={s.cancelAccessBtn} onClick={this.cancelSelection}>Отменить</div>
            </div>
          ) : null}

          {saving ? (
            <div className={s.savingLoader}>
              <Loader fullScreen={false} size={30} />
            </div>
          ) : null}
        </div>
        <div className={s.tableContainer}>
          <Table
            rowKey={r => r.id}
            {...selectionProps}
            pagination={{ current: this.props.page, total: this.props.total }}
            columns={columns}
            onChange={this.changePage}
            loading={loading}
            dataSource={users}
            scroll={{ y: 'calc(100vh - 350px)' }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Sections/Users/Users.js